export const mockedMultipleOrderContactsDataResponse = {
  data: {
    orders: {
      edges: [
        {
          node: {
            id: 'T3JkZXI6MTIwMDcxNjY=',
            referenceNumber: '12007166',
            salesRepresentative: {
              id: 'VXNlcjoyNDczOTA=',
              displayName: 'John Gardener 1234',
              email: 'sales.rep@example.com',
            },
            buyer: {
              name: 'Buyer2',
              email: 'buyer2@example.com',
            },
          },
        },
        {
          node: {
            id: 'T3JkZXI6MTIwMDcxNTc=',
            referenceNumber: '12007157',
            salesRepresentative: {
              id: 'VXNlcjoyNDczOTA=',
              displayName: 'John Gardener 1234',
              email: 'sales.rep@example.com',
            },
            buyer: {
              name: 'Buyer2',
              email: 'buyer2@example.com',
            },
          },
        },
        {
          node: {
            id: 'T3JkZXI6MTIwMDcxNTY=',
            referenceNumber: '12007156',
            salesRepresentative: {
              id: 'VXNlcjoxMTA3NTAw',
              displayName: 'John Gardener 1107500',
              email: 'test_1107500@jooraccess.com',
            },
            buyer: {
              name: 'Buyer2',
              email: 'buyer2@example.com',
            },
          },
        },
        {
          node: {
            id: 'T3JkZXI6MTE4NzU0NTg=',
            referenceNumber: '11875458',
            salesRepresentative: {
              id: 'VXNlcjo3MzgxODY=',
              displayName: 'John Gardener 738186',
              email: 'chu@joor.com',
            },
            buyer: {
              name: 'John Gardener 11875458',
              email: 'test_11875458@jooraccess.com',
            },
          },
        },
        {
          node: {
            id: 'AAAkZXI6MTE4NzU0ABc=',
            referenceNumber: '11110000',
            salesRepresentative: {
              id: 'VXNlcjo3MzgxODY=',
              displayName: 'John Gardener 738186',
              email: 'chu@joor.com',
            },
            buyer: {
              name: 'Buyer2',
              email: 'buyer2@example.com',
            },
          },
        },
      ],
    },
  },
}
